module.exports = __webpack_public_path__ + "img/xingbang-icon.8e4670d0.png";